import { render, staticRenderFns } from "./HrSalaryWealBizClaim.vue?vue&type=template&id=76437092&scoped=true&"
import script from "./HrSalaryWealBizClaim.vue?vue&type=script&lang=js&"
export * from "./HrSalaryWealBizClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76437092",
  null
  
)

export default component.exports